import { render, staticRenderFns } from "./create[project].vue?vue&type=template&id=5516c9f6&"
import script from "./create[project].vue?vue&type=script&lang=js&"
export * from "./create[project].vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports